const KEY = "ll_cookie_consent";
const OPEN_EVENT = "ll:open-cookie-settings";
const CHANGE_EVENT = "ll:consent-changed";

export const getConsent = () => localStorage.getItem(KEY);

export const setConsent = (value) => {
    localStorage.setItem(KEY, value);
    const state = value === "granted" ? "granted" : "denied";
    window.gtag?.("consent", "update", { analytics_storage: state });
    window.dispatchEvent(new Event(CHANGE_EVENT));
};

export const onConsentChange = (handler) => {
    window.addEventListener(CHANGE_EVENT, handler);
    return () => window.removeEventListener(CHANGE_EVENT, handler);
};

export const openCookieSettings = () => window.dispatchEvent(new Event(OPEN_EVENT));

export const onOpenCookieSettings = (handler) => {
    window.addEventListener(OPEN_EVENT, handler);
    return () => window.removeEventListener(OPEN_EVENT, handler);
};
